module.exports = __webpack_public_path__ + "static/media/feeonly.a566f864.png";